import React from 'react';
import BaseNode from './BaseBlockNode';
import { renderPhasesParams } from '../../../constants/phases';

function MeasurementPointNode(props) {
  const {
    presentLoadPhA, presentLoadPhB, presentLoadPhC,
    presentPowerPhA, presentPowerPhB, presentPowerPhC,
  } = props;

  const dynamicParams = renderPhasesParams({
    presentLoadPhA,
    presentLoadPhB,
    presentLoadPhC,
    presentPowerPhA,
    presentPowerPhB,
    presentPowerPhC,
  });

  return (
    <BaseNode
      {...props}
      dynamicParams={dynamicParams}
    />
  );
}

export default MeasurementPointNode;
